module.exports = __webpack_public_path__ + "static/media/entregarinju5.68f4a1ef.jpg";